import React, { useState, useEffect } from 'react'
import ImportEspecialsSpareParts from 'src/pages/ReportsPages/ReportsBoard/SpareParts/ImportEspecialsSpareParts'
import boardReportsService from 'src/services/boardReportsService'

const ImportsOriginalEspecialSparePartsContainer = () => {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [total1, setTotal1] = useState([])
  const [gTotal1, setGTotal1] = useState([])
  const [total2, setTotal2] = useState([])
  const [total3, setTotal3] = useState([])
  const [total4, setTotal4] = useState([])

  const reloadImportsTotal = async () => {
    const [query1, gQuery1, query2, query3, query4] = await Promise.all([
      boardReportsService.getTotalImports('5', selectedDate.getFullYear(), 'tipo=ESPECIALES'),
      boardReportsService.getGTotalImports('2', selectedDate.getFullYear(), 'tipo=ESPECIALES'),
      boardReportsService.getTotalImports('6', selectedDate.getFullYear(), 'tipo=ESPECIALES'),
      boardReportsService.getTotalImports('7', selectedDate.getFullYear(), 'tipo=ESPECIALES'),
      boardReportsService.getTotalImports('12', selectedDate.getFullYear(), 'tipo=ESPECIALES'),
    ])
    setTotal1(query1 || [])
    setGTotal1(gQuery1 || [])
    setTotal2(query2 || [])
    setTotal3(query3 || [])
    setTotal4(query4 || [])
  }

  const handleDateChange = value => {
    setSelectedDate(value)
  }

  useEffect(() => {
    reloadImportsTotal()
  }, [])

  return (
    <ImportEspecialsSpareParts
      total1={total1}
      total2={total2}
      total3={total3}
      total4={total4}
      gTotal1={gTotal1}
      handleDateChange={handleDateChange}
      selectedDate={selectedDate}
    />
  )
}

export default ImportsOriginalEspecialSparePartsContainer
